module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fundao"
  }, [(new Date() < new Date('2024-10-17 00:00')) ? _c('div', {
    staticStyle: {
      "margin": "20px 0",
      "padding": "20px",
      "border": "1px solid #b8bdc2",
      "border-radius": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _c('div', {
    staticClass: "main-container"
  }, [_vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "22px",
      "font-weight": "bolder",
      "text-align": "center",
      "color": "#002d48"
    }
  }, [_c('p', [_vm._v("Chamada Pública nº 2024/008")]), _vm._v(" "), _c('p', [_vm._v("Edital Novo Cataforte ")]), _vm._v(" "), _c('p', [_vm._v("COMUNICADO - PRORROGAÇÃO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "color": "#002D4B"
    }
  }, [_vm._v("Informamos que as inscrições para o Edital Novo Cataforte encerram-se às 23h e 59 min do dia 16/10/2024 (quarta-feira).")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "title-header"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Atualizações no sistema!")])])]), _vm._v(" "), _c('div', {
    staticClass: "texto-principal"
  }, [_c('p', [_vm._v("Prezado parceiro, "), _c('br'), _vm._v("\n                Informamos que foram realizadas alterações de aprimoramento de processos no Sistema de Gerenciamento de Projetos (SGP).\n                Seguem as mudanças realizadas.\n\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "item-mudanca"
  }, [_c('div', [_c('strong', [_vm._v("1.\tRelatório de execução:")])]), _vm._v(" "), _c('div', {
    staticClass: "paragrafo-item"
  }, [_vm._v("\n                        Para a conclusão e envio do Relatório de Execução para a Fundação BB será necessário anexar as  certidões abaixo, informando  as respectivas  datas de vigência: "), _c('br'), _vm._v("\n                        As  certidões são emitidas online gratuitamente conforme endereços indicados abaixo.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-lista"
  }, [_c('div', [_vm._v("•\tCNDT - Certidão Negativa de Débitos Trabalhistas. Emitir em: "), _c('a', {
    attrs: {
      "href": "https://www.tst.jus.br/certidao1",
      "target": "_blank"
    }
  }, [_vm._v("Certidão Negativa de Débitos Trabalhistas - TST")])]), _vm._v(" "), _c('div', [_vm._v("•\tCNEP/CEPIM - Cadastro Nacional de Empresas Punidas – CNEP e Cadastro de Entidades Privadas sem Fins Lucrativos Impedidas – CEPIM e (Lei Anticorrupção nº 12.846/2013). Emitir em: "), _c('a', {
    attrs: {
      "href": "https://certidoes.cgu.gov.br/",
      "target": "_blank"
    }
  }, [_vm._v("Certidões (cgu.gov.br)")])])]), _vm._v(" "), _c('div', {
    staticClass: "paragrafo-item"
  }, [_vm._v("\n                        Informamos que a existência de restrição em qualquer certidão não impedirá a conclusão e o  envio do Relatório. \n                        No entanto, a instituição deverá adotar os procedimentos visando a regularização das pendências identificadas. As pendências  não regularizadas em até 30 dias resultarão no bloqueio no projeto, incluindo a liberação de recursos.\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "item-mudanca"
  }, [_c('div', [_c('strong', [_vm._v("2.\tCadastro dos dirigentes :")])]), _vm._v(" "), _c('div', {
    staticClass: "paragrafo-item"
  }, [_vm._v("\n                        Caso algum dirigente esteja vinculado a outras empresas (como proprietário, participante ou dirigente), será necessário adicionar em seu cadastro, no SGP, o CNPJ de todas as empresas às quais ele esteja vinculado e, também o CNPJ das empresas que tenha se desvinculado há menos de 1 ano.\n                    ")])])]), _vm._v(" "), _c('div', [_vm._v("Para esclarecimento de dúvidas favor utilizar o canal: "), _c('strong', [_vm._v("Chamados")]), _vm._v(". "), _c('br'), _vm._v("Agradecemos a parceria.")]), _vm._v(" "), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-195ffda2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/AvisoMudancas.vue
// module id = 1870
// module chunks = 1